module.exports = __webpack_public_path__ + "static/media/policy-result-success.55230659.svg";